import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-compliance-check-already-used',
  imports: [],
  templateUrl: './compliance-check-already-used.component.html',
})
export class ComplianceCheckAlreadyUsedComponent {
  clientTeamEmailAddress = input.required<string>();
}
